export const role = [
  { Type: "ADMIN" },
  { Type: "REGISTRAR" },
  { Type: "USER" },
];
